// extracted by mini-css-extract-plugin
export var btnBlock = "header-module--btn-block--50d5c";
export var header = "header-module--header--83507";
export var header__desc = "header-module--header__desc--757d9";
export var header__mainDesc = "header-module--header__main-desc--e6180";
export var overtitle = "header-module--overtitle--a8368";